import { IconBook2, IconX } from "@tabler/icons-react";
import type { FC } from "react";
import { Button } from "react-aria-components";
import { MarkdownContent } from "../markdown/markdownContent.js";
import { TextSkeleton } from "../Skeletons/skeletons.js";

export interface ArticleOverlayProps {
  title: string;
  summary: string;
  body: string | undefined;
  isBodyLoading?: boolean;
  onClose: () => void;
}

export const ArticleOverlay: FC<ArticleOverlayProps> = (props) => {
  // ...

  return (
    <div className="isolate grid min-h-0 flex-auto grid-cols-[minmax(0,1fr)] grid-rows-[auto_minmax(0,1fr)_auto]">
      {/* Header */}
      <div className="flex items-center justify-between border-b border-border-light bg-white px-4 py-3">
        <div className="flex items-center gap-2">
          <IconBook2 className="size-4 text-indigo-500" />
          <p className="text-sm font-semibold text-foreground">{props.title}</p>
        </div>
        <Button
          className="hover-text-slate-600 -m-1 rounded-md p-1 text-slate-400 transition-colors hover:bg-slate-100"
          onClick={props.onClose}
        >
          <IconX className="size-5" />
        </Button>
      </div>

      {/* Main */}
      <div className="overflow-y-auto px-4 py-4">
        <p className="mb-3 text-xs text-slate-400">{props.summary}</p>

        {props.body === undefined && props.isBodyLoading ? (
          <TextSkeleton />
        ) : null}

        {props.body !== undefined ? (
          <div className="prose prose-sm">
            <MarkdownContent>{props.body}</MarkdownContent>
          </div>
        ) : null}
      </div>

      {/* Footer */}
      <div className="border-t border-border-light px-4 py-3">
        <Button
          className="w-full rounded-lg bg-slate-100 px-3 py-2 text-xs font-semibold text-slate-600 transition-colors hover:bg-slate-200"
          onClick={props.onClose}
        >
          Back to Coaching
        </Button>
      </div>
    </div>
  );
};
